import React from "react";
import { makeStyles } from "tss-react/mui";
import { isMobileBrowser } from "../../../environment/utils";
import Icon from "../../../icons/components/Icon";
const useStyles = makeStyles()((theme) => {
    return {
        button: {
            padding: "2px",
            backgroundColor: "transparent",
            border: 0,
            outline: 0,
            borderRadius: `${6}px`,
            cursor: "pointer",
            "&:hover": {
                backgroundColor: "#e5eef9",
            },
            "&.focus-visible": {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${"#4687ED"}`,
            },
            "&:active": {
                backgroundColor: "#d1e3f6",
            },
            "&.is-mobile": {
                padding: "10px",
            },
            "& svg": {
                fill: "#4b6790",
            },
        },
    };
});
const ClickableIcon = ({ accessibilityLabel, className, icon, id, onClick, }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("button", { "aria-label": accessibilityLabel, className: cx(styles.button, isMobile && "is-mobile", className), id: id, onClick: onClick },
        React.createElement(Icon, { size: 24, src: icon })));
};
export default ClickableIcon;
